import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtPT: CultureInfo = {
  name: 'pt-PT',
  displayName: 'Portuguese (Portugal)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-PT',
  parent: CultureInfoPt
};
